import React, { useCallback, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import AgGridNew from '../../grid/ag/ag-grid-new';
import NavigationHeder from '../../Navigations/NavigationHeder';
import ButtonNew from '../../inc/ButtonNew';
import { useNavigate } from 'react-router-dom';
import { gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import AppFormsPopup from './AppFormsPopup';
import Helper from '../../../inc/Helper';
import DatepickerFunctions from '../../../inc/DatepickerHelper';

let gridApi = null;
const AppFormsListing = () => {
    const [openPopupView, setOpenPopupView] = useState(false);

    const navigate = useNavigate();
 
    const onClickRedirectToDetailView = (event) => {   
        if(event.colDef.field === 'name') {  
            navigate(`/edit-app-form/${event?.data?.id}`)
        }
    }

    const onClickPopupView = () => {
        setOpenPopupView(true);
    }

    const onDeleteIntegrationDocument = useCallback(async (element) => { 
        let api = Api;
        api.setUserToken();
        
        let delDocument_ID = element?.data?.id;

        try {
            const res = await api
            .axios()
            .delete(Settings.apiAppUrl+`/app/${delDocument_ID}/`)

            const rowNode = gridApi?.getRowNode(delDocument_ID)
            
            if (rowNode) {
                rowNode.setSelected(false)
            }
            
            setTimeout(() => {
                const transaction = { remove: [element?.data] }
                gridApi?.applyServerSideTransaction(transaction) 
            }, 200);

            gridApi?.refreshServerSide({ purge: true })
            gridApi?.deselectAll();
            
            Helper.alert(res?.data?.message || 'App deleted successfully', 'success')
        } catch (err) {
            getPopupMessageBasedOnStatus(err)
        }
    }, []);

    const reloadParentGrid = () => {
        gridApi?.refreshServerSide({ purge: true });
        gridApi?.deselectAll();
    };

    const gridColumnHeaders = [
        {field:'name', filter: 'agTextColumnFilter', headerName:'Name', editable:false, cellRenderer: (params) => gridLinkValueFormat(params) },
        {field:'redirect_uri', valueFormatter: (params) => params?.value ? (params?.value) : '-', headerName:'Redirect URI', editable: false },
        {field:'created_datetime', headerName:'Created date time', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', editable: false },
        {field:'created_by', valueFormatter: (params) => params?.value ? (params?.value) : '-', headerName:'Created by', editable: false },
        {field:'modified_datetime', headerName:'Modified date time', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateTimeFromDataBase(params?.value) : '-', editable: false },
        {field:'modified_by', valueFormatter: (params) => params?.value ? (params?.value) : '-', headerName:'Modified by', editable: false }
    ];

    return ( 
        <div className='container-fluid'>
            <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'App'}>
                <ButtonNew onClick={onClickPopupView} title={'New'}  />
            </NavigationHeder>

            <AgGridNew
                apiUrl={Settings.apiAppUrl+'/app/'} 
                pagination={false}
                columnDefs={gridColumnHeaders} 
                hideAddBtn={true}
                height={500}
                uniqueField={'id'}
                onCellClicked={onClickRedirectToDetailView}
                handleDeleteSelectedRows={onDeleteIntegrationDocument}
                onGridReady={(params) => gridApi = params?.api} 
                gridId={"app_forms_listing_grid"}
            />

            {openPopupView && <AppFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
        </div> 
    )
}

export default (MasterComponentWraper(AppFormsListing));